const API_URL = process.env.REACT_APP_API_URL;

export async function getTicketPriorities() {
    const response = await fetch(`${API_URL}/ticket/priorites`, {
        method: "GET",
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error("Failed to fetch ticket priorities");
    }
    return response.json();
}

export async function getTicketTypes() {
    const response = await fetch(`${API_URL}/ticket/types`, {
        method: "GET",
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error("Failed to fetch ticket types");
    }
    return response.json();
}

export async function getTicketStatuts() {
    const response = await fetch(`${API_URL}/statuts`, {
        method: "GET",
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error("Failed to fetch ticket statuts");
    }
    return response.json();
}

// POST créer un type de ticket
export async function createTicketType(typeData) {
    const response = await fetch(`${API_URL}/ticket/type`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            type: {
                nom: typeData.nom,
                label: typeData.label,
                couleur: typeData.couleur,
                defaut: typeData.defaut
            }
        }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la création du type de ticket");
    }
    return response.json();
}

// PUT mettre à jour un type de ticket
export async function updateTicketType(typeId, typeData) {
    const response = await fetch(`${API_URL}/ticket/type/${typeId}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            type: {
                nom: typeData.nom,
                label: typeData.label,
                couleur: typeData.couleur,
                defaut: typeData.defaut
            }
        }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la mise à jour du type de ticket");
    }
    return response.json();
}

// DELETE supprimer un type de ticket
export async function deleteTicketType(typeId) {
    const response = await fetch(`${API_URL}/ticket/type/${typeId}`, {
        method: "DELETE",
        credentials: "include",
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la suppression du type de ticket");
    }
    return response.json();
}

// GET méthodes de facturation
export async function getFacturationModes() {
    const response = await fetch(`${API_URL}/ticket/facturations`, {
        method: "GET",
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error("Failed to fetch facturation modes");
    }
    return response.json();
}

// POST créer une méthode de facturation
export async function createFacturationMode(modeData) {
    const response = await fetch(`${API_URL}/ticket/facturation`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            facturation: {
                label: modeData.label,
                couleur: modeData.couleur,
                defaut: modeData.defaut
            }
        }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la création de la méthode de facturation");
    }
    return response.json();
}

// PUT mettre à jour une méthode de facturation
export async function updateFacturationMode(modeId, modeData) {
    const response = await fetch(`${API_URL}/ticket/facturation/${modeId}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            facturation: {
                label: modeData.label,
                couleur: modeData.couleur,
                defaut: modeData.defaut
            }
        }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la mise à jour de la méthode de facturation");
    }
    return response.json();
}

// DELETE supprimer une méthode de facturation
export async function deleteFacturationMode(modeId) {
    const response = await fetch(`${API_URL}/ticket/facturation/${modeId}`, {
        method: "DELETE",
        credentials: "include",
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la suppression de la méthode de facturation");
    }
    return response.json();
}

// POST créer une priorité
export async function createTicketPriority(priorityData) {
    const response = await fetch(`${API_URL}/ticket/priorite`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            priorite: {
                nom: priorityData.nom,
                label: priorityData.label
            }
        }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la création de la priorité");
    }
    return response.json();
}

// PUT mettre à jour une priorité
export async function updateTicketPriority(priorityId, priorityData) {
    const response = await fetch(`${API_URL}/ticket/priorite/${priorityId}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            priorite: {
                nom: priorityData.nom,
                label: priorityData.label
            }
        }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la mise à jour de la priorité");
    }
    return response.json();
}

// DELETE supprimer une priorité
export async function deleteTicketPriority(priorityId) {
    const response = await fetch(`${API_URL}/ticket/priorite/${priorityId}`, {
        method: "DELETE",
        credentials: "include",
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la suppression de la priorité");
    }
    return response.json();
}
